<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户贷款申请'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <div class="xzpadd10 of">
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :filters.sync="filters"
          :actions="actions"
        />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "CustomerApplyingList",
        data(){
          return{
            applicationStatus: 'Pending Approval',
            roleData:{},
            dealerOptions:[],
            tableData: {
              count: 0,
              data: []
            },
            dealerTypeOptions:[],
            page: 1,
            pageSize: 20,
            actions: [
              /*{
                label: '新增',
                class: 'el-icon-plus',
                clickHandler: ()=>{
                  this.$router.push({
                    path: 'add'
                  })
                }
              }*/
            ],
            filters: {
              labelWidth: '150px',
              form: {
                ba__customerName:'',
                ba__customerContactNo:'',
                d__dealerId:'',
                t__applicationDate:[],
              },
              columns: [
                {
                  label: '客户姓名',
                  component: 'el-input',
                  field: 'ba__customerName'
                },
                /*{
                  label: '手机号',
                  component: 'el-input',
                  field: 'ba__customerContactNo'
                },*/
                {
                  label: '渠道商',
                  component: 'el-select',
                  field: 'd__dealerId',
                  options:this.dealerOptions,
                },
                {
                  label: '导入日期',
                  component: 'date-range-picker',
                  field: 't__applicationDate',
                  op: ['gteq', 'lteq'],
                },



              ],
              onSubmit:()=>{
                this.page = 1
                this.getData()
              }
            }
          }
        },
        computed:{
          columns: function(){
            return [
              {
                type: 'index'
              },
              {
                label: '客户姓名',
                field: 'ba__customerName'
              },
              /*{
                label: '手机号',
                field: 'ba__customerContactNo'
              },*/
              {
                label: '身份证号码',
                field: 'ba__customerIC'
              },
              {
                label: '渠道商',
                field: 'd__dealerName'
              },
              {
                label: '客户来源',
                field: 'ba__channel'
              },
              {
                label: '导入时间',
                field: 't__applicationDate',
                formatter: function (r,c,v) {
                  return moment(v).format('YYYY-MM-DD HH:mm')
                }
              },
              {
                label: '操作',
                opts:[
                  {
                    label: '发起贷款申请',
                    class: 'el-icon-success',
                    clickHandler: (index, row) => {
                      this.$router.push({
                        name: 'FinancingAddView',
                        query: {
                          'applicationId': row.t__applicationId,
                          /* 'creditId': row.cr__creditId || ''*/
                        }
                      })
                    },
                    conditions: row=> {
                      return row.t__applicationStatus=='Approved'

                    }
                  },

                ]
              }
            ]
          },
          filterParams: {
            get: function() {
              return {
                pageSize: this.pageSize,
                pageOffset: (this.page - 1) * this.pageSize,
                'xlist.search.t.applicationStatus' :'Approved',
                'xlist.search.t.applicationStatus.op' : 'in',
                  'xlist.search.d.forLender' :'N',
                  'xlist.search.d.forLender.op' : 'eq',
                'xlist.sort.dataField': 't.applicationDate',
                'xlist.sort.order': 'desc'
              }
            },
            set:function (newVal) {

            }
          }
        },
        watch: {
          filterParams: function () {
            this.getData()
          },
        },

        mounted() {
          this.getData()
          this.getDealerList()
        },
        methods: {
          getData: function () {
            xhr.getApplyingCustomerFangList(
              Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
              res => {
                try {
                  this.tableData = res.data
                  this.roleData = res.data.variables
                } catch (e) {

                }
              })
          },
          getDealerList: function () {
            xhr.getDealerList(
              Object.assign({pageSize:0}, {}, {}),
              res=> {
                try {
                  this.filters.columns[1].options = res.data.data.map(item=>{
                    return {
                      label: item.d__dealerName,
                      value:item.d__dealerId,
                    }
                  })
                }catch(e){

                }
              })

          },

          approveCustomerKF: function (index, row) {
            this.$router.push({
              name: 'CustomerApplyingFangApproveKF',
              query: {
                'applicationId': row.t__applicationId,
               /* 'creditId': row.cr__creditId || ''*/
              }
            })
          },

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerApproveList.vue